import React from 'react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';
import '../../styles/ui/OfflineBanner.css';

function OfflineBanner({ onRetry }) {
  const online = useOnlineStatus();

  if (online) return null;

  return (
    <div className="offline-banner" role="alert">
      <span className="offline-banner-text">لا يوجد اتصال بالإنترنت — تحقق من الشبكة</span>
      {onRetry && (
        <button type="button" className="offline-banner-retry" onClick={onRetry}>
          إعادة المحاولة
        </button>
      )}
    </div>
  );
}

export default OfflineBanner;
